import { css } from '@emotion/react';
import { styled } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';

import weight200 from './Assets/externalCSS/MontserratFont/weight200.woff2';
import weight300 from './Assets/externalCSS/MontserratFont/weight300.woff2';
import weight400 from './Assets/externalCSS/MontserratFont/weight400.woff2';
import weight500 from './Assets/externalCSS/MontserratFont/weight500.woff2';
import weight600 from './Assets/externalCSS/MontserratFont/weight600.woff2';
import weight700 from './Assets/externalCSS/MontserratFont/weight700.woff2';

const unicodeRange =
  'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD';

export const globalStyles = css`
  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url(${weight200}) format('woff2');
    unicode-range: ${unicodeRange};
  }

  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url(${weight300}) format('woff2');
    unicode-range: ${unicodeRange};
  }

  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${weight400}) format('woff2');
    unicode-range: ${unicodeRange};
  }

  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(${weight500}) format('woff2');
    unicode-range: ${unicodeRange};
  }

  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url(${weight600}) format('woff2');
    unicode-range: ${unicodeRange};
  }

  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${weight700}) format('woff2');
    unicode-range: ${unicodeRange};
  }
  * {
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
  }

  body {
    margin: 0;
    font-family: 'Montserrat', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: var(--backgroundColor);
    overflow: hidden;
  }

  button {
    font-family: 'Montserrat', sans-serif !important;
  }

  ::-ms-reveal {
    display: none;
  }

  code {
    font-family: 'Montserrat', sans-serif;
  }

  p {
    margin: 0;
  }

  :root {
    --primaryColor: #2d3a47;
    --secondaryColor: #f57b20;
    --tertiaryColor: #fef2e9;
    --backgroundColor: #fbfbfb;
    --blackColor: #000;
    --whiteColor: #fff;
    --dangerColor: #ff5252;
    --successColor: #4bb543;
    --statusResolvedColor: #5f9936;
    --statusResolvedBackgroundColor: #ebf2e6;
    --statusAssignedColor: #e7bb09;
    --statusAssignedBackgroundColor: #fcf7e0;
    --statusOverdueColor: #e03b24;
    --statusOverdueBackgroundColor: #fbe7e4;
    --statusUnassignedColor: #3865a3;
    --statusUnassignedBackgroundColor: #e6ecf4;
    --warningBackgroundColor: #fcf8e3;
    --borderWidth: 2px;
    --navbarHeight: 76px;
    --sidedrawerWidth: 75px;
    --navbarSpace: calc(var(--navbarHeight) / 3);
    --shrunk-width: 0px;
    --chat-bar-height: 95px;
    --line-chart-month: 0px;
    --input-background-color: #f1f1f1;
    --disabled-text-color: rgba(191, 191, 191, 1);
    --link-color: #2075f5;
  }

  ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-inline-start: 25px;
  }

  /* for demo */
  div[class^='Screen-module_root'] {
    height: calc(100% - 146px) !important;
  }

  div[class^='MuiAutocomplete-popper'] {
    z-index: 99999 !important;
  }

  .MuiMenu-root.panel-popover {
    z-index: 6000;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  #rbgcp-gradient-bar-canvas {
    pointer-events: none;
  }

  /* Auth CSSTransition classes (2000ms) */
  .menu-primary-enter {
    position: absolute;
    transform: translateX(-100%);
  }

  .menu-primary-enter-active {
    transform: translateX(0%);
    transition: all 2000ms ease;
  }

  .menu-primary-exit {
    position: absolute;
  }

  .menu-primary-exit-active {
    transform: translateX(-100%);
    transition: all 2000ms ease;
  }

  .menu-secondary-enter {
    transform: translateX(100%);
  }

  .menu-secondary-enter-active {
    transform: translateX(0%);
    transition: all 2000ms ease;
  }

  .menu-secondary-exit-active {
    transform: translateX(100%);
    transition: all 2000ms ease;
  }

  /* WorkflowEditorSidebar CSSTransition classes (500ms) */
  .menu-primary-sidebar-enter {
    position: absolute;
    transform: translateX(-110%);
  }

  .menu-primary-sidebar-enter-active {
    transform: translateX(0%);
    transition: all 500ms ease;
  }

  .menu-primary-sidebar-exit {
    position: absolute;
  }

  .menu-primary-sidebar-exit-active {
    transform: translateX(-110%);
    transition: all 500ms ease;
  }

  .menu-secondary-sidebar-enter {
    transform: translateX(110%);
  }

  .menu-secondary-sidebar-enter-active {
    transform: translateX(0%);
    transition: all 500ms ease;
  }

  .menu-secondary-sidebar-exit-active {
    transform: translateX(110%);
    transition: all 500ms ease;
  }

  /* WorkflowEditorDrawer */
  .react-transform-wrapper {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const StyledToastContainer = styled(ToastContainer)`
  &&&.Toastify__toast-container[data-stacked='true'] {
    width: 500px;
  }

  .Toastify__toast {
    background-color: white;
    box-shadow: ${({ theme }) => theme.boxShadows.box};
    border-radius: 10px;
    padding: 15px 20px;
  }

  /* default toast */

  .Toastify__toast--default {
    border-top: 8px solid #2d3a47;
  }

  .Toastify__progress-bar--default {
    background: #969ca3;
  }

  /* info toast */

  .Toastify__toast--info {
    border-top: 8px solid #0088ff;
  }

  .Toastify__progress-bar--info {
    background: #80c3ff;
  }

  /* warning toast */

  .Toastify__toast--warning {
    border-top: 8px solid #e7bb09;
  }

  .Toastify__progress-bar--warning {
    background: #f3dd84;
  }

  /* error toast */

  .Toastify__toast--error {
    border-top: 8px solid #d83a52;
  }

  .Toastify__progress-bar--error {
    background: #eb9ca9q;
  }

  /* success toast */

  .Toastify__toast--success {
    border-top: 8px solid #2a8725;
  }

  .Toastify__progress-bar--success {
    background: #94c392;
  }

  /* progress bar bg */

  .Toastify__progress-bar--default.Toastify__progress-bar--bg,
  .Toastify__progress-bar--info.Toastify__progress-bar--bg,
  .Toastify__progress-bar--success.Toastify__progress-bar--bg,
  .Toastify__progress-bar--warning.Toastify__progress-bar--bg,
  .Toastify__progress-bar--error.Toastify__progress-bar--bg {
    background: #969ca3;
  }

  .Toastify__toast-icon {
    display: none;
  }
`;
